import { Box, Typography } from '@mui/material'
import React from 'react'
import { UnitTypes } from 'src/Libs/types'

interface Props {
  price: number
  className: string
}

/**
 * component to create a chart label for the current time
 * @param price
 * @param className
 */
const PowerPriceChartLabel: React.FC<Props> = ({ price, className }) => {
  const priceFormatted = Math.round(price)

  return (
    <Box className={className}>
      <Typography variant="h1">
        {priceFormatted}
        <Typography variant="h2" component="span">{` ${UnitTypes.centsPerKiloWattHour}`}</Typography>
      </Typography>
    </Box>
  )
}

export default PowerPriceChartLabel
